














































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';

@Component({
  name: 'bpc-resource-online-booking-config-form',
  components: {
    BpcSwitch,
  },
})
export default class SwitchWithDescription extends Vue {
  @Prop(Boolean) readonly value: boolean;
  @Prop(Boolean) readonly loadingDefaultDescription: boolean;
  @Prop(Object) readonly switchProperties: any;
  @Prop(Array) readonly descriptionItems: { name: string; description: string; id: number }[];
  @Prop(Boolean) readonly avoidGrouping: boolean;

  get switchModel() {
    return this.value;
  }

  set switchModel(value: boolean) {
    this.$emit('input', value);
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get groupedDescriptionItems(): { groupName: string; description: string; ids: string }[] {
    // Utilizar reduce para agrupar los elementos por descripción
    const groupedMap = this.descriptionItems.reduce((acc, item) => {
      if (!acc[item.description]) {
        acc[item.description] = { names: [], ids: [] };
      }
      acc[item.description].names.push(item.name);
      acc[item.description].ids.push(item.id);
      return acc;
    }, {} as { [key: string]: { names: string[]; ids: number[] } });

    // Convertir el objeto agrupado a un array de GroupedItem
    return Object.keys(groupedMap).map(description => ({
      groupName: groupedMap[description].names.join(', '),
      description,
      ids: groupedMap[description].ids.join(', '),
    }));
  }
}
